/**
 * API host from REACT_APP_API_URL.
 * - Development: empty string → same-origin `/api/...` via setupProxy.js
 *   (the proxy target is REACT_APP_API_URL, so local dev avoids CORS)
 * - Production: REACT_APP_API_URL, no trailing slash, else the host this site
 *   has always called. An empty origin is not neutral -- it makes every request
 *   same-origin, and CloudFront answers those with index.html.
 *
 * Create React App inlines this at `npm run build`. A .env file on the live
 * host is never read. Production builds load `.env.production`.
 */
const PROD_API_ORIGIN = "https://api-v2.socialspectrum.org";

const configuredApiUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export const API_ORIGIN =
  process.env.NODE_ENV === "development" ? "" : configuredApiUrl || PROD_API_ORIGIN;

export const websiteApi = (path) =>
  `${API_ORIGIN}/api/website${path.startsWith("/") ? path : `/${path}`}`;

export const webApi = (path) =>
  `${API_ORIGIN}/api/web${path.startsWith("/") ? path : `/${path}`}`;
